/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _range = _interopRequireDefault(require("../../../../common/range"));
function prepareAlignOffset(alignOffset, positionsLength) {
  var offset;
  if (Array.isArray(alignOffset)) {
    offset = alignOffset.map(function (alignOffsetItem) {
      if (typeof alignOffsetItem === 'number') {
        return {
          x: alignOffsetItem,
          y: alignOffsetItem
        };
      } else {
        return alignOffsetItem;
      }
    });
  }
  if (typeof alignOffset === 'number') {
    offset = {
      x: alignOffset,
      y: alignOffset
    };
  }
  if ((0, _typeof2.default)(alignOffset) === 'object') {
    offset = alignOffset;
  }
  if (!Array.isArray(offset) && positionsLength) {
    offset = (0, _range.default)(0, positionsLength).map(function () {
      return offset;
    });
  }
  return offset;
}
var _default = prepareAlignOffset;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Menu/src/utils/prepareAlignOffset.js
// module id = 262
// module chunks = 0